export default {"src":"/login-app/[GIT_HASH]/_next/static/media/issue.68ea5fa4.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};